import { cn, SupportIcon, Text } from '$components'

type SupportLinkProps = {
  onClick: () => void
}

export function SupportLink({ onClick }: SupportLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex gap-2 p-3 items-center rounded-2xl w-full',
        'hover:bg-gray-100 text-gray-900',
      )}
    >
      <SupportIcon className="size-[20px] min-w-[20px] min-h-[20px]" />

      <Text className="truncate text-sm">
        Support
      </Text>
    </button>
  )
}
